import * as React from 'react'
import { FC, useCallback } from 'react'
import { ReducerProps } from '../reducer'
import { getSelectButtonsStyles as getStyles } from './styles'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useTheme } from '@mui/material/styles'

export const SelectButtons: FC<ReducerProps> = (props) => {
  const { dispatch, hideDefaultBtn = false } = props
  const theme = useTheme()
  const { button } = getStyles(theme)

  const selectAll = useCallback(
    () => dispatch({ type: 'select', payload: 'all' }),
    [dispatch],
  )

  const selectNone = useCallback(
    () => dispatch({ type: 'select', payload: 'none' }),
    [dispatch],
  )

  const resetDefault = useCallback(() => {
    dispatch({ type: 'resetDefault' })
  }, [dispatch])

  return (
    <Box display="flex">
      <Button
        onClick={selectAll}
        sx={button}
        color="primary"
        variant="outlined"
        size="small"
      >
        Select All
      </Button>
      <Button
        onClick={selectNone}
        sx={button}
        color="primary"
        variant="outlined"
        size="small"
      >
        Select None
      </Button>
      {!hideDefaultBtn && (
        <Button
          onClick={resetDefault}
          sx={button}
          color="primary"
          variant="text"
          size="small"
        >
          Reset to default
        </Button>
      )}
    </Box>
  )
}
